import { useEffect } from "react";

const TitleChnage = (title) => {

    useEffect( () => {
        document.title = title;
    },[title])

}

export default TitleChnage